import { render, staticRenderFns } from "./PdfAttachmentField.vue?vue&type=template&id=33256ffe&scoped=true&"
import script from "./PdfAttachmentField.vue?vue&type=script&lang=js&"
export * from "./PdfAttachmentField.vue?vue&type=script&lang=js&"
import style0 from "./PdfAttachmentField.vue?vue&type=style&index=0&id=33256ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33256ffe",
  null
  
)

export default component.exports